export enum Role {
  ROLE_ADMIN = 'admin' as any,
  ROLE_SALES_MANAGER = 'salesmanager' as any,
  ROLE_SALES_PERSON = 'salesperson' as any,
  ROLE_TEAM_LEADER = 'teamleader' as any,
}
